module.exports = __webpack_public_path__ + "static/lyu-d50e823f768ff496a8ca0de3e02a7038.png";